import { useQuery } from '@tanstack/react-query';

import { sdk } from '@/services';

const UserInfoService = sdk.getService('UserInfoService');

export const useUserInfoByUser = (userId?: string | undefined) => {
  const queryKey = ['user-info', userId];

  const { data, isPending } = useQuery({
    queryKey,
    queryFn: () => UserInfoService.getUserInfoById(userId!),
    enabled: !!userId && userId !== undefined
  });

  return { userInfo: data, isPending };
};
